import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SuperAdminService } from "src/app/super-admin.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-view-own-vehicle-expense",
  templateUrl: "./view-own-vehicle-expense.component.html",
  styleUrls: ["./view-own-vehicle-expense.component.css"],
})
export class ViewOwnVehicleExpenseComponent implements OnInit {
  expense: any = null;
  isLoading = false;
  apiUrl = environment.domain;
  constructor(
    private route: ActivatedRoute,
    private superAdminService: SuperAdminService,
  ) {}

  ngOnInit(): void {
    const expenseId = this.route.snapshot.paramMap.get("id");
    if (expenseId) {
      this.getExpenseById(expenseId);
    }
  }

  getExpenseById(id: string) {
    this.isLoading = true;

    this.superAdminService.getParticularOwnVehicleExpense(id).subscribe(
      (res) => {
        this.isLoading = false;
        if (res.status) {
          this.expense = res.data;
        }
      },
      () => {
        this.isLoading = false;
      },
    );
  }

  backTo() {
    window.history.back();
  }
}
